/**
 * Master Muscles — share the cart (cart page only, M1.11).
 * Same links as the old cart page: a /cart/<variant>:<qty>,... permalink, copied, sent by WhatsApp or by the phone's share sheet.
 * Changes on purpose: free tier-gift lines are left out (the permalink would add them at full price on the other side), and the link is built
 * from Shopify.routes.root (keeps /ar) with ?storefront=true: without it a /cart/<variant>:<qty> permalink redirects straight to CHECKOUT
 * (no cart page, so no offer bridge and no gift ladder, and an English checkout for an Arabic shopper). With it the receiver lands on /cart.
 */
(function () {
  'use strict';

  function root() {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return r.charAt(r.length - 1) === '/' ? r : r + '/';
  }

  function isAr() {
    return /^ar/i.test(document.documentElement.lang || '');
  }

  function toast(msg, type) {
    if (window.MMCart && typeof window.MMCart.showToast === 'function') window.MMCart.showToast(msg, type);
  }

  function cartLink() {
    return fetch(root() + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var parts = (cart.items || [])
          .filter(function (it) { return !(it.properties && it.properties._gift === 'true'); })
          .map(function (it) { return it.variant_id + ':' + it.quantity; });
        return parts.length ? window.location.origin + root() + 'cart/' + parts.join(',') + '?storefront=true' : '';
      });
  }

  function copyText(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) return navigator.clipboard.writeText(text);
    return new Promise(function (resolve, reject) {
      try {
        var input = document.createElement('input');
        input.value = text;
        document.body.appendChild(input);
        input.select();
        var ok = document.execCommand('copy');
        document.body.removeChild(input);
        ok ? resolve() : reject(new Error('copy'));
      } catch (e) { reject(e); }
    });
  }

  function flashLabel(btn, text) {
    var label = btn.querySelector('[data-mm-share-label]');
    if (!label) return;
    if (!label._orig) label._orig = label.textContent;
    label.textContent = text;
    clearTimeout(btn._t);
    btn._t = setTimeout(function () { label.textContent = label._orig; }, 2000);
  }

  function onClick(e) {
    var btn = e.target.closest('[data-mm-share-do]');
    if (!btn) return;
    var wrap = btn.closest('[data-mm-share]');
    var message = (wrap && wrap.getAttribute('data-share-msg')) || 'Master Muscles';
    var type = btn.getAttribute('data-mm-share-do');
    // WhatsApp: the window is opened inside the tap (a window.open after the fetch is blocked by iOS Safari and in-app browsers) and pointed at wa.me later.
    var wa = null;
    if (type === 'whatsapp') { try { wa = window.open('about:blank', '_blank'); } catch (e) { wa = null; } }
    var closeWa = function () { if (wa) { try { wa.close(); } catch (e) { /* already closed */ } wa = null; } };
    cartLink().then(function (url) {
      if (!url) { closeWa(); return; }
      if (type === 'whatsapp') {
        var href = 'https://wa.me/?text=' + encodeURIComponent(message + ' ' + url);
        if (wa) {
          try { wa.opener = null; } catch (e) { /* cross-origin guard */ }
          wa.location.href = href;
        } else {
          // popups are blocked: copy the link instead of losing the tap
          copyText(url).then(function () { flashLabel(btn, isAr() ? 'تم النسخ ✓' : 'Copied ✓'); }).catch(function () { toast(isAr() ? 'تعذّر النسخ' : 'Could not copy', 'error'); });
        }
      } else if (type === 'native' && navigator.share) {
        navigator.share({ title: 'Master Muscles', text: message, url: url }).catch(function () {});
      } else {
        copyText(url).then(function () {
          flashLabel(btn, isAr() ? 'تم النسخ ✓' : 'Copied ✓');
        }).catch(function () {
          toast(isAr() ? 'تعذّر النسخ' : 'Could not copy', 'error');
        });
      }
    }).catch(function () {
      closeWa();
      toast(isAr() ? 'تعذّرت المشاركة' : 'Could not share the cart', 'error');
    });
  }

  document.addEventListener('click', onClick);
})();
